import { format, utcToZonedTime } from "date-fns-tz";
import { useTranslation } from "react-i18next";

import { ReactComponent as HotelsCalendarIcon } from "../../images/global/calendar-hotels.svg";
import { ReactComponent as HotelsEurostarIcon } from "../../images/global/eurostar-hotels.svg";
import { ReactComponent as HotelsBedIcon } from "../../images/global/cro1381-beds.svg";
import { ReactComponent as HotelsTicketsIcon } from "../../images/global/tickets-hotels.svg";
import { ReactComponent as HotelsAdultIcon } from "../../images/global/cro1381-adult-hotel-icon.svg";
import { ReactComponent as HotelsChildIcon } from "../../images/global/cro1381-child-hotel-icon.svg";
import { ReactComponent as HotelsInfantIcon } from "../../images/global/cro1381-infant-hotel-icon.svg";

const Accommodation = ({ accommodation, transport, styles }) => {
  const { t } = useTranslation("common");

  const weekDayDateFrom = accommodation.dates.from && format(
    utcToZonedTime(new Date(accommodation.dates.from), "UTC"),
    "EEEE",
    { timeZone: "UTC" }
  );
  const dateFrom = accommodation.dates.from && format(
    utcToZonedTime(new Date(accommodation.dates.from), "UTC"),
    "dd MMM yyyy",
    { timeZone: "UTC" }
  );
  const weekDayDateTo = accommodation.dates.to && format(
    utcToZonedTime(new Date(accommodation.dates.to), "UTC"),
    "EEEE",
    { timeZone: "UTC" }
  );
  const dateTo = accommodation.dates.to && format(
    utcToZonedTime(new Date(accommodation.dates.to), "UTC"),
    "dd MMM yyyy",
    { timeZone: "UTC" }
  );

  const adultQty = accommodation.total_guests.adult;
  const childQty = accommodation.total_guests.child;
  const infantQty = accommodation.total_guests.infant;

  return (
    <div className={styles.cartItem} id="floating-cart-traveling-info">
      <div className={styles.cro1381HotelMeta}>
        <ul className={styles.cro1381HotelDetails}>
          <li>
            <HotelsCalendarIcon />
            <p data-testId='accommodation-dates'>
              {weekDayDateFrom} {dateFrom} - {weekDayDateTo} {dateTo}
            </p>
          </li>
          <li
            className={styles.cro1381HotelGuests}
            id="floating-cart-hotel-room-summary"
          >
            <div className={styles.cro1381GuestMeta} data-testid='adults-qty'>
              <HotelsAdultIcon />{adultQty} Adults
            </div>
            {childQty > 0 && (
              <div className={styles.cro1381GuestMeta} data-testid='children-qty'>
                <HotelsChildIcon />{childQty} Children
              </div>
            )}
            {infantQty > 0 && (
              <div className={styles.cro1381GuestMeta} data-testid='infants-qty'>
                <HotelsInfantIcon />{infantQty} Infants
              </div>
            )}
          </li>
          {transport.carrier && (
            <li>
              <HotelsEurostarIcon />
              <p>
                <strong>{transport.carrier}</strong>
              </p>
            </li>
          )}
          <li>
            <HotelsBedIcon />
            <p data-testid="nights">
              <strong>
                {accommodation.dates.number_of_nights} {t("nights")}
              </strong>
            </p>
          </li>
          {accommodation.tickets_included !== "" && (
            <li>
              <HotelsTicketsIcon />
              <p data-testId='park-tickets-details'>
                <strong >{accommodation.tickets_included}</strong>
              </p>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Accommodation;
